import MenuItem from "./MenuItem";

export type { IMenuItemProps } from "./MenuItem";

export default MenuItem;
